export default __webpack_public_path__ + "static/media/01_Kom_Hochbunker Bottrop.976b5888.jpg";